import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";

import { deferGraphemeUntilNextLocalDay } from "#defer-grapheme-until-next-local-day";

/** Mutation form of {@link deferGraphemeUntilNextLocalDay}, bound to the actor database context. */
export function useDeferGraphemeUntilNextLocalDay() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);

  return useMutation({
    mutationFn: (grapheme: string) =>
      deferGraphemeUntilNextLocalDay({ actorDb, grapheme, now: new Date() }),
    mutationKey: ["deferGraphemeUntilNextLocalDay"],
  });
}
